export const PLAYBACK_RATE = 'playbackRate';

export const PLAYBACK_RATES: Record<string, PlaybackRates> = {
    slow: 0.5,
    normal: 1,
    fast: 1.5,
    faster: 2,
    fastest: 3,
};

export const MENU: Record<string, Menu> = {
    SETTINGS: 'SETTINGS',
    QUALITY: 'QUALITY',
    SPEED: 'SPEED',
};

export const AUTOPLAY: {
    NAME: string;
    ENABLED: AutoPlayEnabled;
    DISABLED: AutoPlayEnabled;
} = {
    NAME: 'autoplayEnabled',
    ENABLED: true,
    DISABLED: false,
};
